var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_2051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47916 16.1542L0.400391 8.40033L8.47916 0.646484L10.0004 2.10864L3.44655 8.40033L10.0004 14.692L8.47916 16.1542Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_2051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 17,
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBackArrow);
export default __webpack_public_path__ + "static/media/black_back_arrow.82da168bbef724266b8e2ccb2a365db5.svg";
export { ForwardRef as ReactComponent };